<template>
  <section class="full-width-home-section">
    <div class="not-found">
      <h1>404</h1>
      <p>Oops! The page you are looking for doesn't exist.</p>
      <router-link to="/">Go back to Home</router-link>
    </div>
  </section>

</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped></style>